import { useState, useEffect } from "react";
import {
  getProperties,
  createProperties,
  getSocietyAmenitiesList,
  getMasterPropertyTypes,
  getMasterChargeTypes,
  getSocietiesList,
  getPropertyById,
  updatePropertyById,
  getTenantsList,
  assignTenantToProperty,
  togglePropertyStatusById,
  vacantTenantyById,
} from "../../../services/propertyOwner/propertyOwnerServices";
import toast from "../../../utils/toast";

export default function Rooms() {
  const [isPropertiesList, setPropertiesList] = useState(null);
  const [listLoading, setListLoading] = useState(true);
  const [filters, setFilters] = useState({
    societyId: "",
    propertyTypeId: "",
    pageNumber: 1,
    pageSize: 10,
  });
  const [societiesList, setSocietiesList] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [chargeTypes, setChargeTypes] = useState([]);
  const [amenitiesList, setAmenitiesList] = useState([]);
  const [isModalOpenAddProperty, setIsModalOpenAddProperty] = useState(false);
  const [addPropertyLoading, setAddPropertyLoading] = useState(false);
  const [addPropertyErrors, setAddPropertyErrors] = useState({});
  const [isModalOpenEditProperty, setIsModalOpenEditProperty] = useState(false);
  const [editPropertyLoading, setEditPropertyLoading] = useState(false);
  const [editPropertyErrors, setEditPropertyErrors] = useState({});
  const [editPropertyForm, setEditPropertyForm] = useState({});
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [isTenantsListData, setTenantsListData] = useState(null);
  const [isModalOpenAssignTenant, setIsModalOpenAssignTenant] = useState(false);
  const [selectedPropertyForAssign, setSelectedPropertyForAssign] =
    useState(null);
  const [assignTenantId, setAssignTenantId] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const INITIAL_PROPERTY_FORM = {
    societyId: "",
    propertyTypeId: "",
    unitNo: "",
    houseNo: "",
    floor: 0,
    bedrooms: 1,
    bathrooms: 1,
    areaSqFt: "",
    attachedWashroom: true,
    kitchenAvailable: false,
    rentAmount: "",
    securityDeposit: "",
    dueDayOfMonth: 5,
    notes: "",
    amenityIds: [],
    customAmenity: "",
    isActive: true,
    billCharges: [],
  };

  const [addPropertyForm, setAddPropertyForm] = useState(INITIAL_PROPERTY_FORM);

  const selectedType = propertyTypes.find(
    (t) => t.propertyTypeId === Number(addPropertyForm.propertyTypeId),
  );
  const isRoom = selectedType?.propertyTypeName === "Room";
  const isRowHouse = selectedType?.propertyTypeName === "RowHouse";

  const FREQ_OPTIONS = [
    "Monthly",
    "Quarterly",
    "HalfYearly",
    "Yearly",
    "OneTime",
  ];
  const BILLING_METHOD_OPTIONS = ["Fixed", "PerUnit", "Percentage"];

  const getBillingMethodDisplay = (method) => {
    if (method === "Fixed")
      return {
        label: "₹ Fixed",
        bg: "var(--blue-light)",
        color: "var(--blue)",
      };
    if (method === "PerUnit")
      return {
        label: "Per Unit",
        bg: "var(--teal-light)",
        color: "var(--teal)",
      };
    if (method === "Percentage")
      return {
        label: "% of Rent",
        bg: "var(--purple-light)",
        color: "var(--purple)",
      };
    return {
      label: method,
      bg: "var(--bg-secondary)",
      color: "var(--text-primary)",
    };
  };

  // ── useEffects ──
  useEffect(() => {
    fetchProperties();
  }, [filters]);

  useEffect(() => {
    fetchPropertyTypes();
    fetchSocieties();
  }, []);

  useEffect(() => {
    if (isModalOpenAddProperty || isModalOpenEditProperty) {
      fetchAmenities();
      fetchChargeTypes();
    }
  }, [isModalOpenAddProperty, isModalOpenEditProperty]);

  useEffect(() => {
    if (isModalOpenAssignTenant) {
      fetchTenantsList();
    }
  }, [isModalOpenAssignTenant]);

  const fetchSocieties = async () => {
    try {
      const res = await getSocietiesList();
      if (res.statusCode === 1) setSocietiesList(res.data.societies);
    } catch (err) {
      console.log("Failed to fetch societies");
    }
  };

  const fetchTenantsList = async () => {
    try {
      const res = await getTenantsList();
      setTenantsListData(res);
    } catch (err) {
      console.log("Failed to fetch tenants");
    }
  };

  const fetchProperties = async () => {
    setListLoading(true);
    try {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      );
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      const res = await getProperties(params);

      if (res.statusCode === 1) {
        setPropertiesList(res.data);
        setTotalCount(res.data.paging.totalCount);
        setTotalPages(res.data.paging.totalPages);
      }
    } catch (error) {
      console.log("Failed to fetch properties");
    } finally {
      setListLoading(false);
    }
  };

  const fetchPropertyTypes = async () => {
    try {
      const res = await getMasterPropertyTypes();
      const active = res.filter((t) => t.isActive);
      setPropertyTypes(active);
    } catch (err) {
      console.log("Failed to fetch property types");
    }
  };

  const fetchChargeTypes = async () => {
    try {
      const res = await getMasterChargeTypes();
      setChargeTypes(res.filter((t) => t.isActive));
    } catch (err) {
      console.log("Failed to fetch charge types");
    }
  };

  const fetchAmenities = async () => {
    try {
      const res = await getSocietyAmenitiesList();
      if (res.statusCode === 1) {
   
      setAmenitiesList(Array.isArray(res.data) ? res.data : res.data.amenities || []);
    }
    } catch (err) {
      console.log("Failed to fetch amenities");
    }
  };

  // ── Helpers ──
  const getPropertyIcon = (type) => {
    const icons = { Room: "🛏", Flat: "🏠", RowHouse: "🏡", Shop: "🏪" };
    return icons[type] || "🏠";
  };

  const getSpecsLabel = (p) => {
    const parts = [];
    if (p.propertyType !== "Room" && p.bedrooms) parts.push(`${p.bedrooms}BHK`);
    if (p.attachedWashroom) parts.push("🚿 Attached");
    if (p.kitchenAvailable) parts.push("🍳");
    if (p.bathrooms > 1) parts.push(`${p.bathrooms} WR`);
    return parts.join(" · ") || "—";
  };

  // ── Filter handlers ──
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value, pageNumber: 1 }));
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({ ...prev, pageNumber: page }));
  };

  // ── Modal open/close ──
  const openAddPropertyModal = () => {
    setAddPropertyForm({
      ...INITIAL_PROPERTY_FORM,
      societyId: societiesList[0]?.societyId || "",
      propertyTypeId: propertyTypes[0]?.propertyTypeId || "",
    });
    setAddPropertyErrors({});
    setIsModalOpenAddProperty(true);
  };

  const closeAddPropertyModal = () => {
    setIsModalOpenAddProperty(false);
    setAddPropertyForm(INITIAL_PROPERTY_FORM);
    setAddPropertyErrors({});
  };

  // ── Form handlers ──
  const handleAddPropertyChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAddPropertyForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setAddPropertyErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAmenityToggle = (amenityId) => {
    setAddPropertyForm((prev) => ({
      ...prev,
      amenityIds: prev.amenityIds.includes(amenityId)
        ? prev.amenityIds.filter((id) => id !== amenityId)
        : [...prev.amenityIds, amenityId],
    }));
  };

  // ── Bill charge handlers ──
  const addBillCharge = (chargeType) => {
    setAddPropertyForm((prev) => ({
      ...prev,
      billCharges: [
        ...prev.billCharges,
        {
          _id: Date.now(),
          chargeTypeId: chargeType.chargeTypeId,
          chargeName: `${chargeType.icon} ${chargeType.chargeTypeName}`,
          frequency: "Monthly",
          billingMethod: "Fixed",
          amount: "",
          allowPartialPay: false,
          sortOrder: prev.billCharges.length,
        },
      ],
    }));
  };

  const removeBillCharge = (id) => {
    setAddPropertyForm((prev) => ({
      ...prev,
      billCharges: prev.billCharges.filter((c) => c._id !== id),
    }));
  };

  const updateBillCharge = (id, field, value) => {
    setAddPropertyForm((prev) => ({
      ...prev,
      billCharges: prev.billCharges.map((c) =>
        c._id === id ? { ...c, [field]: value } : c,
      ),
    }));
  };

  // ── Validate ──
  const validateAddProperty = () => {
    const e = {};
    if (!addPropertyForm.societyId) e.societyId = "Society is required.";
    if (!addPropertyForm.unitNo && !addPropertyForm.houseNo)
      e.unitNo = "Unit / House number is required.";
    if (!addPropertyForm.rentAmount) e.rentAmount = "Rent amount is required.";
    setAddPropertyErrors(e);
    return Object.keys(e).length === 0;
  };

  // ── Submit ──
  const handleCreateProperty = async () => {
    if (!validateAddProperty()) return;
    setAddPropertyLoading(true);
    try {
      const payload = {
        societyId: Number(addPropertyForm.societyId),
        propertyTypeId: Number(addPropertyForm.propertyTypeId),
        unitNo: addPropertyForm.unitNo,
        houseNo: addPropertyForm.houseNo,
        floor: Number(addPropertyForm.floor),
        bedrooms: Number(addPropertyForm.bedrooms),
        bathrooms: Number(addPropertyForm.bathrooms),
        areaSqFt: Number(addPropertyForm.areaSqFt) || 0,
        attachedWashroom: addPropertyForm.attachedWashroom,
        kitchenAvailable: addPropertyForm.kitchenAvailable,
        rentAmount: Number(addPropertyForm.rentAmount),
        securityDeposit: Number(addPropertyForm.securityDeposit) || 0,
        dueDayOfMonth: Number(addPropertyForm.dueDayOfMonth),
        notes: addPropertyForm.notes,
        amenityIds:
          addPropertyForm.amenityIds.length > 0
            ? addPropertyForm.amenityIds
            : [0],
        customAmenity: addPropertyForm.customAmenity,
        isActive: addPropertyForm.isActive,
        billCharges: addPropertyForm.billCharges.map((c, i) => ({
          chargeTypeId: c.chargeTypeId,
          frequency: c.frequency,
          billingMethod: c.billingMethod,
          amount: Number(c.amount) || 0,
          allowPartialPay: c.allowPartialPay,
          sortOrder: i,
        })),
      };
      const res = await createProperties(payload);
      if (res.statusCode === 1) {
        toast.success(res.message || "Property created successfully.");
        closeAddPropertyModal();
        fetchProperties();
      } else {
        toast.error(res.message || "Failed to create property.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setAddPropertyLoading(false);
    }
  };

  const openEditPropertyModal = async (propertyId) => {
    try {
      const res = await getPropertyById(propertyId);
      if (res.statusCode === 1) {
        const d = res.data;
        setSelectedProperty(d);
        setEditPropertyForm({
          societyId: d.societyId,
          propertyTypeId: d.propertyTypeId,
          unitNo: d.unitNo || "",
          houseNo: d.houseNo || "",
          floor: d.floor ?? 0,
          bedrooms: d.bedrooms ?? 1,
          bathrooms: d.bathrooms ?? 1,
          areaSqFt: d.areaSqFt || "",
          attachedWashroom: d.attachedWashroom,
          kitchenAvailable: d.kitchenAvailable,
          rentAmount: d.rentAmount || "",
          securityDeposit: d.securityDeposit || "",
          dueDayOfMonth: d.dueDayOfMonth ?? 5,
          notes: d.notes || "",
          amenityIds: d.amenityIds
            ? d.amenityIds.split(",").map(Number).filter(Boolean)
            : [],
          customAmenity: d.customAmenity || "",
          isActive: d.isActive,
          billCharges:
            d.billCharges?.map((c, i) => ({
              _id: Date.now() + i,
              chargeTypeId: c.chargeTypeId,
              chargeName:
                `${c.chargeTypeIcon || ""} ${c.chargeTypeName || ""}`.trim(),
              frequency: c.frequency,
              billingMethod: c.billingMethod,
              amount: c.amount,
              allowPartialPay: c.allowPartialPay,
              sortOrder: c.sortOrder,
            })) || [],
        });
        setEditPropertyErrors({});
        setIsModalOpenEditProperty(true);
      }
    } catch (err) {
      toast.error("Failed to load property details.");
    }
  };

  const closeEditPropertyModal = () => {
    setIsModalOpenEditProperty(false);
    setSelectedProperty(null);
    setEditPropertyForm({});
    setEditPropertyErrors({});
  };

  const handleEditPropertyChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditPropertyForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setEditPropertyErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEditAmenityToggle = (amenityId) => {
    setEditPropertyForm((prev) => ({
      ...prev,
      amenityIds: prev.amenityIds.includes(amenityId)
        ? prev.amenityIds.filter((id) => id !== amenityId)
        : [...prev.amenityIds, amenityId],
    }));
  };

  const addEditBillCharge = (chargeType) => {
    setEditPropertyForm((prev) => ({
      ...prev,
      billCharges: [
        ...prev.billCharges,
        {
          _id: Date.now(),
          chargeTypeId: chargeType.chargeTypeId,
          chargeName: `${chargeType.icon} ${chargeType.chargeTypeName}`,
          frequency: "Monthly",
          billingMethod: "Fixed",
          amount: "",
          allowPartialPay: false,
          sortOrder: prev.billCharges.length,
        },
      ],
    }));
  };

  const removeEditBillCharge = (id) => {
    setEditPropertyForm((prev) => ({
      ...prev,
      billCharges: prev.billCharges.filter((c) => c._id !== id),
    }));
  };

  const updateEditBillCharge = (id, field, value) => {
    setEditPropertyForm((prev) => ({
      ...prev,
      billCharges: prev.billCharges.map((c) =>
        c._id === id ? { ...c, [field]: value } : c,
      ),
    }));
  };

  const validateEditProperty = () => {
    const e = {};
    if (!editPropertyForm.societyId) e.societyId = "Society is required.";
    if (!editPropertyForm.unitNo && !editPropertyForm.houseNo)
      e.unitNo = "Unit / House number is required.";
    if (!editPropertyForm.rentAmount) e.rentAmount = "Rent amount is required.";
    setEditPropertyErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleUpdateProperty = async () => {
    if (!validateEditProperty()) return;
    setEditPropertyLoading(true);
    try {
      const payload = {
        societyId: Number(editPropertyForm.societyId),
        propertyTypeId: Number(editPropertyForm.propertyTypeId),
        unitNo: editPropertyForm.unitNo,
        houseNo: editPropertyForm.houseNo,
        floor: Number(editPropertyForm.floor),
        bedrooms: Number(editPropertyForm.bedrooms),
        bathrooms: Number(editPropertyForm.bathrooms),
        areaSqFt: Number(editPropertyForm.areaSqFt) || 0,
        attachedWashroom: editPropertyForm.attachedWashroom,
        kitchenAvailable: editPropertyForm.kitchenAvailable,
        rentAmount: Number(editPropertyForm.rentAmount),
        securityDeposit: Number(editPropertyForm.securityDeposit) || 0,
        dueDayOfMonth: Number(editPropertyForm.dueDayOfMonth),
        notes: editPropertyForm.notes,
        amenityIds:
          editPropertyForm.amenityIds.length > 0
            ? editPropertyForm.amenityIds
            : [0],
        customAmenity: editPropertyForm.customAmenity,
        isActive: editPropertyForm.isActive,
        billCharges: editPropertyForm.billCharges.map((c, i) => ({
          chargeTypeId: c.chargeTypeId,
          frequency: c.frequency,
          billingMethod: c.billingMethod,
          amount: Number(c.amount) || 0,
          allowPartialPay: c.allowPartialPay,
          sortOrder: i,
        })),
      };
      const res = await updatePropertyById(
        selectedProperty.propertyId,
        payload,
      );
      if (res.statusCode === 1) {
        toast.success(res.message || "Property updated successfully.");
        closeEditPropertyModal();
        fetchProperties();
      } else {
        toast.error(res.message || "Failed to update property.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setEditPropertyLoading(false);
    }
  };

  const selectedEditType = propertyTypes.find(
    (t) => t.propertyTypeId === Number(editPropertyForm.propertyTypeId),
  );
  const isEditRoom = selectedEditType?.propertyTypeName === "Room";
  const isEditRowHouse = selectedEditType?.propertyTypeName === "RowHouse";

  const handleAssignSave = async () => {
    if (!assignTenantId) {
      toast.error("Please select a tenant.");
      return;
    }
    try {
      const res = await assignTenantToProperty(
        selectedPropertyForAssign.propertyId,
        {
          tenantId: Number(assignTenantId),
        },
      );
      if (res.statusCode === 1) {
        toast.success(res.message);
        setIsModalOpenAssignTenant(false);
        fetchProperties();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    }
  };

  const handleToggleUnitStatus = async (id, status) => {
    try {
      const payload = {
        isActive: !status,
      };
      const res = await togglePropertyStatusById(id, payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        fetchProperties();
      }
    } catch (err) {
      toast.error("Failed to toggle  status.");
    }
  };

  const removeTenatById = async (id) => {
    try {
      const res = await vacantTenantyById(id);
      if (res.statusCode === 1) {
        toast.success(res.message);
        fetchProperties();
      }
    } catch (err) {
      toast.error("Failed to remove tenant.");
    }
  };

  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title">Units / Rooms</div>
            <div className="page-sub">Manage rooms, flats &amp; row houses</div>
          </div>
          <div className="topbar-right">
            <button className="btn btn-primary" onClick={openAddPropertyModal}>
              + Add Property
            </button>
          </div>
        </div>

        <div className="content">
          {/* Stat Cards */}
          <div className="stat-grid mb16">
            <div className="stat-card">
              <div className="stat-icon">🛏</div>
              <div className="stat-label">Rooms</div>
              <div className="stat-value">
                {isPropertiesList?.roomsCount ?? 0}
              </div>
              <div className="stat-delta delta-neu">Single rooms</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🏠</div>
              <div className="stat-label">Flats</div>
              <div className="stat-value">
                {isPropertiesList?.flatsCount ?? 0}
              </div>
              <div className="stat-delta delta-neu">Apartments</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🏡</div>
              <div className="stat-label">Row Houses</div>
              <div className="stat-value">
                {isPropertiesList?.rowHousesCount ?? 0}
              </div>
              <div className="stat-delta delta-neu">Independent</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Occupied</div>
              <div className="stat-value">
                {isPropertiesList?.occupiedCount ?? 0}
              </div>
              <div className="stat-delta delta-up">Active tenancies</div>
            </div>
          </div>

          <div className="card">
            {/* Filters */}
            <div className="flex-between mb12">
              <div className="card-title" style={{ margin: 0 }}>
                All Properties
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <select
                  name="societyId"
                  value={filters.societyId}
                  onChange={handleFilterChange}
                  style={{ fontSize: 12, padding: "5px 8px", width: "auto" }}
                >
                  <option value="">All Societies</option>
                  {societiesList.map((s) => (
                    <option key={s.societyId} value={s.societyId}>
                      {s.name}
                    </option>
                  ))}
                </select>

                <select
                  name="propertyTypeId"
                  value={filters.propertyTypeId}
                  onChange={handleFilterChange}
                  style={{ fontSize: 12, padding: "5px 8px", width: "auto" }}
                >
                  <option value="">All Types</option>
                  {propertyTypes.map((t) => (
                    <option key={t.propertyTypeId} value={t.propertyTypeId}>
                      {t.icon} {t.propertyTypeName}
                    </option>
                  ))}
                </select>

                {(filters.societyId || filters.propertyTypeId) && (
                  <button
                    className="btn btn-lg"
                    style={{ background: "#185fa5", color: "#fff" }}
                    onClick={() =>
                      setFilters({
                        societyId: "",
                        propertyTypeId: "",
                        pageNumber: 1,
                        pageSize: 10,
                      })
                    }
                  >
                    Reset
                  </button>
                )}
              </div>
            </div>

            {/* Table */}
            <div style={{ overflowX: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Unit</th>
                    <th>Type</th>
                    <th>Society</th>
                    <th>Area</th>
                    <th>Specs</th>
                    <th>Rent</th>
                    <th>Security Deposit</th>
                    <th>Tenant</th>
                    <th>Unit Status</th>
                    <th>Tenant Status</th>
                    <th style={{ minWidth: 160 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listLoading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <tr key={i}>
                        {Array.from({ length: 12 }).map((_, j) => (
                          <td key={j}>
                            <div
                              style={{
                                height: 14,
                                borderRadius: 6,
                                background:
                                  "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                                backgroundSize: "200% 100%",
                                animation: "shimmer 1.4s infinite",
                                width:
                                  j === 2 ? "80%" : j === 12 ? "60%" : "70%",
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : isPropertiesList?.properties?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={12}
                        style={{
                          textAlign: "center",
                          color: "var(--text-tertiary)",
                          padding: 24,
                        }}
                      >
                        No properties found.
                      </td>
                    </tr>
                  ) : (
                    isPropertiesList?.properties?.map((p, index) => (
                      <tr key={p.propertyId}>
                        <td className="sn-col">
                          {(filters.pageNumber - 1) * Number(filters.pageSize) +
                            index +
                            1}
                        </td>

                        <td style={{ whiteSpace: "nowrap" }}>
                          {getPropertyIcon(p.propertyType)}
                          <strong>
                            {p.propertyType === "Room" ||
                            p.propertyType === "Flat"
                              ? `${p.propertyType} ${p.unitNo}`
                              : p.houseNo || p.unitNo}
                          </strong>
                          <div
                            style={{
                              fontSize: 10,
                              color: "var(--text-tertiary)",
                            }}
                          >
                            Floor {p.floor ?? "—"}
                          </div>
                        </td>
                        <td>
                          <span className="badge badge-info">
                            {p.propertyType}
                          </span>
                        </td>
                        <td style={{ fontSize: 11, whiteSpace: "nowrap" }}>
                          {p.societyName || "—"}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {p.areaSqFt} sq. ft
                        </td>
                        <td
                          style={{
                            fontSize: 11,
                            color: "var(--text-secondary)",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getSpecsLabel(p)}
                        </td>
                        <td>
                          ₹{Number(p.rentAmount).toLocaleString("en-IN")}/
                          {p.rentFrequency}
                        </td>
                        <td>₹{p.securityDeposit}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {p.currentTenantName ? (
                            <>
                              <div style={{ fontWeight: 600, fontSize: 12 }}>
                                {p.currentTenantName}
                              </div>
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "var(--text-secondary)",
                                }}
                              >
                                📱 {p.currentTenantMobile}
                              </div>
                            </>
                          ) : (
                            <span
                              style={{
                                fontSize: 11,
                                color: "var(--text-tertiary)",
                                fontStyle: "italic",
                              }}
                            >
                              — Vacant —
                            </span>
                          )}
                        </td>
                        <td>
                          <span
                            className={`badge ${p.isActive ? "badge-active" : "badge-inactive"}`}
                          >
                            {p.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge ${p.status === "Occupied" ? "badge-active" : "badge-gray"}`}
                          >
                            {p.status}
                          </span>
                        </td>
                        <td>
                          <div className="td-actions">
                            <span
                              className="action-icon"
                              title="Edit Property"
                              onClick={() =>
                                openEditPropertyModal(p.propertyId)
                              }
                            >
                              <span className="tip">Edit Property</span>✎
                            </span>

                            <span
                              className="action-icon blue"
                              title="Assign Tenant"
                              onClick={() => {
                                setSelectedPropertyForAssign(p);
                                setAssignTenantId("");
                                setIsModalOpenAssignTenant(true);
                              }}
                            >
                              <span className="tip">Assign Tenant</span>👤
                            </span>
                            <span className="action-icon" title="Meter History">
                              <span className="tip">Meter History</span>⚡
                            </span>

                            {p.status === "Occupied" ? (
                              // Occupied hai — sirf vacant karne ka option
                              <span
                                className="action-icon red"
                                title="Mark Vacant"
                                onClick={() => removeTenatById(p.propertyId)}
                              >
                                <span className="tip">
                                  Mark Vacant (remove tenant)
                                </span>
                                🔓
                              </span>
                            ) : (
                              // Vacant hai — toggle active/inactive ka option
                              <span
                                className="action-icon amber"
                                title={
                                  p.isActive
                                    ? "Deactivate Unit"
                                    : "Activate Unit"
                                }
                                onClick={() =>
                                  handleToggleUnitStatus(
                                    p.propertyId,
                                    p.isActive,
                                  )
                                }
                              >
                                <span className="tip">
                                  {p.isActive
                                    ? "Deactivate Unit"
                                    : "Activate Unit"}
                                </span>
                                ⊘
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "var(--text-secondary)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <select
                  name="pageSize"
                  value={filters.pageSize}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      pageSize: Number(e.target.value),
                      pageNumber: 1,
                    }))
                  }
                  style={{ fontSize: 12, padding: "4px 8px" }}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>
                <span>
                  Showing{" "}
                  <strong>{isPropertiesList?.properties?.length ?? 0}</strong>{" "}
                  of <strong>{totalCount}</strong>
                </span>
              </div>

              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <button
                  className="btn btn-xs"
                  disabled={filters.pageNumber === 1}
                  onClick={() => handlePageChange(filters.pageNumber - 1)}
                >
                  ‹ Prev
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <span
                      key={page}
                      onClick={() => handlePageChange(page)}
                      style={{
                        padding: "2px 8px",
                        background:
                          filters.pageNumber === page
                            ? "var(--blue)"
                            : "transparent",
                        color:
                          filters.pageNumber === page
                            ? "#fff"
                            : "var(--text-secondary)",
                        borderRadius: 5,
                        fontSize: 11,
                        cursor: "pointer",
                        border:
                          filters.pageNumber === page
                            ? "none"
                            : "1px solid var(--border-mid)",
                      }}
                    >
                      {page}
                    </span>
                  ),
                )}

                <button
                  className="btn btn-xs"
                  disabled={filters.pageNumber === totalPages}
                  onClick={() => handlePageChange(filters.pageNumber + 1)}
                >
                  Next ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add Property Modal ── */}
      {isModalOpenAddProperty && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 860, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">Add New Property</div>
              <button className="modal-close" onClick={closeAddPropertyModal}>
                ✕
              </button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
                maxHeight: "78vh",
                overflowY: "auto",
                padding: 20,
              }}
            >
              {/* ── LEFT ── */}
              <div>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    marginBottom: 12,
                  }}
                >
                  Property Details
                </div>

                {/* Society */}
                <div className="form-group mb12">
                  <label>Society *</label>
                  <select
                    name="societyId"
                    value={addPropertyForm.societyId}
                    onChange={handleAddPropertyChange}
                    style={
                      addPropertyErrors.societyId
                        ? { borderColor: "#dc2626" }
                        : {}
                    }
                  >
                    {/* <option value="">Select Society</option>
                    {uniqueSocieties.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))} */}
                    <option value="">Select Society</option>
                    {societiesList.map((s) => (
                      <option key={s.societyId} value={s.societyId}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                  {addPropertyErrors.societyId && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addPropertyErrors.societyId}
                    </span>
                  )}
                </div>

                {/* Property Type */}
                <div className="form-group mb12">
                  <label>Property Type *</label>
                  <select
                    name="propertyTypeId"
                    value={addPropertyForm.propertyTypeId}
                    onChange={handleAddPropertyChange}
                    style={{ fontSize: 14, fontWeight: 600 }}
                  >
                    <option value="">Select Type</option>
                    {propertyTypes.map((t) => (
                      <option key={t.propertyTypeId} value={t.propertyTypeId}>
                        {t.icon} {t.propertyTypeName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Unit No — Room / Flat */}
                {!isRowHouse && (
                  <div className="form-group mb12">
                    <label>{isRoom ? "Room Number" : "Unit Number"} *</label>
                    <input
                      type="text"
                      name="unitNo"
                      value={addPropertyForm.unitNo}
                      onChange={handleAddPropertyChange}
                      placeholder="e.g. 101, A-204"
                      style={
                        addPropertyErrors.unitNo
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {addPropertyErrors.unitNo && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {addPropertyErrors.unitNo}
                      </span>
                    )}
                  </div>
                )}

                {/* House No — Row House */}
                {isRowHouse && (
                  <div className="form-group mb12">
                    <label>House Number *</label>
                    <input
                      type="text"
                      name="houseNo"
                      value={addPropertyForm.houseNo}
                      onChange={handleAddPropertyChange}
                      placeholder="e.g. RH-12, House No. 5"
                      style={
                        addPropertyErrors.unitNo
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {addPropertyErrors.unitNo && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {addPropertyErrors.unitNo}
                      </span>
                    )}
                  </div>
                )}

                {/* Floor */}
                <div className="form-group mb12">
                  <label>Floor Number</label>
                  <select
                    name="floor"
                    value={addPropertyForm.floor}
                    onChange={handleAddPropertyChange}
                  >
                    <option value={0}>Ground Floor</option>
                    {Array.from({ length: 20 }, (_, i) => i + 1).map((f) => (
                      <option key={f} value={f}>
                        {f}
                        {f === 1
                          ? "st"
                          : f === 2
                            ? "nd"
                            : f === 3
                              ? "rd"
                              : "th"}{" "}
                        Floor
                      </option>
                    ))}
                  </select>
                </div>

                {/* Room toggles */}
                {isRoom && (
                  <div
                    style={{
                      display: "flex",
                      gap: 20,
                      marginBottom: 12,
                      padding: "10px 12px",
                      background: "var(--bg-secondary)",
                      borderRadius: "var(--radius-md)",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      <label className="toggle">
                        <input
                          type="checkbox"
                          name="attachedWashroom"
                          checked={addPropertyForm.attachedWashroom}
                          onChange={handleAddPropertyChange}
                        />
                        <span className="toggle-slider" />
                      </label>
                      Attached Washroom
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      <label className="toggle">
                        <input
                          type="checkbox"
                          name="kitchenAvailable"
                          checked={addPropertyForm.kitchenAvailable}
                          onChange={handleAddPropertyChange}
                        />
                        <span className="toggle-slider" />
                      </label>
                      Kitchen Available
                    </label>
                  </div>
                )}

                {/* Bedrooms / Bathrooms — Flat & RowHouse */}
                {!isRoom && (
                  <div className="form-grid mb12">
                    <div className="form-group">
                      <label>Bedrooms</label>
                      <select
                        name="bedrooms"
                        value={addPropertyForm.bedrooms}
                        onChange={handleAddPropertyChange}
                      >
                        {[1, 2, 3, 4, 5, 6].map((n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Washrooms</label>
                      <select
                        name="bathrooms"
                        value={addPropertyForm.bathrooms}
                        onChange={handleAddPropertyChange}
                      >
                        {[1, 2, 3, 4].map((n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Financial */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    margin: "14px 0 10px",
                  }}
                >
                  Financial
                </div>

                <div className="form-grid mb12">
                  <div className="form-group">
                    <label>Rent Amount (₹) *</label>
                    <input
                      type="number"
                      name="rentAmount"
                      value={addPropertyForm.rentAmount}
                      onChange={handleAddPropertyChange}
                      placeholder="e.g. 8500"
                      min={0}
                      style={
                        addPropertyErrors.rentAmount
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {addPropertyErrors.rentAmount && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {addPropertyErrors.rentAmount}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Security Deposit (₹)</label>
                    <input
                      type="number"
                      name="securityDeposit"
                      value={addPropertyForm.securityDeposit}
                      onChange={handleAddPropertyChange}
                      placeholder="e.g. 17000"
                      min={0}
                    />
                  </div>
                </div>

                <div className="form-group mb12">
                  <label>Rent Due Date</label>
                  <select
                    name="dueDayOfMonth"
                    value={addPropertyForm.dueDayOfMonth}
                    onChange={handleAddPropertyChange}
                  >
                    {[
                      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 25,
                      28,
                    ].map((d) => (
                      <option key={d} value={d}>
                        {d}
                        {d === 1
                          ? "st"
                          : d === 2
                            ? "nd"
                            : d === 3
                              ? "rd"
                              : "th"}{" "}
                        of every month
                      </option>
                    ))}
                  </select>
                </div>

                {/* Bill Charges */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    margin: "14px 0 10px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  Bill Charges
                  <select
                    style={{
                      fontSize: 11,
                      padding: "2px 6px",
                      fontWeight: 400,
                      textTransform: "none",
                      letterSpacing: 0,
                      background: "#185fa5",
                      color: "#fff",
                    }}
                    value=""
                    onChange={(e) => {
                      const found = chargeTypes.find(
                        (c) => c.chargeTypeId === Number(e.target.value),
                      );
                      if (found) addBillCharge(found);
                    }}
                  >
                    <option value="">+ Add Charges</option>
                    {chargeTypes.map((c) => (
                      <option key={c.chargeTypeId} value={c.chargeTypeId}>
                        {c.icon} {c.chargeTypeName}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  {addPropertyForm.billCharges.map((charge) => {
                    const methodDisplay = getBillingMethodDisplay(
                      charge.billingMethod,
                    );
                    return (
                      <div
                        key={charge._id}
                        style={{
                          border: "0.5px solid var(--border-light)",
                          borderRadius: "var(--radius-md)",
                          padding: 12,
                          background: "var(--bg-secondary)",
                        }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1.5fr 1fr auto 28px",
                            gap: 8,
                            alignItems: "end",
                            marginBottom: 8,
                          }}
                        >
                          {/* Charge name */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                              }}
                            >
                              Charge Name
                            </label>
                            <div
                              style={{
                                padding: "7px 10px",
                                background: "var(--bg-primary)",
                                border: "0.5px solid var(--border-mid)",
                                borderRadius: "var(--radius-md)",
                                fontSize: 13,
                                fontWeight: 600,
                              }}
                            >
                              {charge.chargeName}
                            </div>
                          </div>
                          {/* Frequency */}
                          <div className="form-group" style={{ margin: 0 }}>
                            <label style={{ fontSize: 10, marginBottom: 3 }}>
                              Frequency
                            </label>
                            <select
                              value={charge.frequency}
                              onChange={(e) =>
                                updateBillCharge(
                                  charge._id,
                                  "frequency",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: 12, padding: "6px 8px" }}
                            >
                              {FREQ_OPTIONS.map((f) => (
                                <option key={f} value={f}>
                                  {f}
                                </option>
                              ))}
                            </select>
                          </div>
                          {/* Billing Method */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                              }}
                            >
                              Billing Method
                            </label>
                            <select
                              value={charge.billingMethod}
                              onChange={(e) =>
                                updateBillCharge(
                                  charge._id,
                                  "billingMethod",
                                  e.target.value,
                                )
                              }
                              style={{
                                fontSize: 11,
                                padding: "4px 6px",
                                background: methodDisplay.bg,
                                color: methodDisplay.color,
                                fontWeight: 700,
                                border: "none",
                                borderRadius: 99,
                              }}
                            >
                              {BILLING_METHOD_OPTIONS.map((m) => (
                                <option key={m} value={m}>
                                  {getBillingMethodDisplay(m).label}
                                </option>
                              ))}
                            </select>
                          </div>
                          {/* Remove */}
                          <button
                            onClick={() => removeBillCharge(charge._id)}
                            style={{
                              width: 28,
                              height: 28,
                              border: "0.5px solid #F09595",
                              background: "var(--red-light)",
                              color: "var(--red)",
                              borderRadius: 5,
                              cursor: "pointer",
                              fontSize: 15,
                              alignSelf: "flex-end",
                            }}
                          >
                            ×
                          </button>
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr auto",
                            gap: 12,
                            alignItems: "center",
                          }}
                        >
                          <div className="form-group" style={{ margin: 0 }}>
                            <label style={{ fontSize: 10, marginBottom: 3 }}>
                              {charge.billingMethod === "Percentage"
                                ? "Value (%)"
                                : charge.billingMethod === "PerUnit"
                                  ? "Rate (₹/unit)"
                                  : "Amount (₹)"}
                            </label>
                            <input
                              type="number"
                              value={charge.amount}
                              onChange={(e) =>
                                updateBillCharge(
                                  charge._id,
                                  "amount",
                                  e.target.value,
                                )
                              }
                              placeholder={
                                charge.billingMethod === "PerUnit"
                                  ? "e.g. 8.5"
                                  : charge.billingMethod === "Percentage"
                                    ? "e.g. 10"
                                    : "e.g. 500"
                              }
                              min={0}
                              step="0.01"
                              style={{ fontSize: 12, padding: "6px 8px" }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Partial Pay
                            </label>
                            <label className="toggle">
                              <input
                                type="checkbox"
                                checked={charge.allowPartialPay}
                                onChange={(e) =>
                                  updateBillCharge(
                                    charge._id,
                                    "allowPartialPay",
                                    e.target.checked,
                                  )
                                }
                              />
                              <span className="toggle-slider" />
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* ── RIGHT ── */}
              <div>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    marginBottom: 10,
                  }}
                >
                  Property Amenities
                </div>

                <div
                  style={{
                    maxHeight: 300,
                    overflowY: "auto",
                    paddingRight: 4,
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                  >
                    {(amenitiesList || [])?.map((amenity) => (
                      <label
                        key={amenity.amenityId}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 8,
                          fontSize: 12,
                          cursor: "pointer",
                          padding: "6px 10px",
                          border: `0.5px solid ${addPropertyForm.amenityIds.includes(amenity.amenityId) ? "var(--blue)" : "var(--border-light)"}`,
                          borderRadius: "var(--radius-md)",
                          background: addPropertyForm.amenityIds.includes(
                            amenity.amenityId,
                          )
                            ? "var(--blue-light)"
                            : "var(--bg-primary)",
                          userSelect: "none",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={addPropertyForm.amenityIds.includes(
                            amenity.amenityId,
                          )}
                          onChange={() =>
                            handleAmenityToggle(amenity.amenityId)
                          }
                          style={{ marginTop: 2, flexShrink: 0 }}
                        />
                        <span style={{ fontSize: 16, flexShrink: 0 }}>
                          {amenity.icon}
                        </span>
                        <span>
                          <span style={{ fontWeight: 600 }}>
                            {amenity.amenityName}
                          </span>
                          {amenity.description && (
                            <div
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                                marginTop: 1,
                                lineHeight: "1.4",
                              }}
                            >
                              {amenity.description}
                            </div>
                          )}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Area */}
                <div className="form-group mb12">
                  <label>Area (sq ft)</label>
                  <input
                    type="number"
                    name="areaSqFt"
                    value={addPropertyForm.areaSqFt}
                    onChange={handleAddPropertyChange}
                    placeholder="e.g. 450"
                    min={0}
                  />
                </div>

                {/* Notes */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    margin: "14px 0 10px",
                  }}
                >
                  Instructions / Notes for Tenant
                </div>
                <textarea
                  name="notes"
                  value={addPropertyForm.notes}
                  onChange={handleAddPropertyChange}
                  style={{ minHeight: 110, width: "100%" }}
                  placeholder="e.g. No loud music after 10 PM. Guests must register at reception."
                />
                <div className="input-hint" style={{ marginTop: 4 }}>
                  Shown to the tenant in their dashboard and agreement
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn"
                onClick={closeAddPropertyModal}
                disabled={addPropertyLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleCreateProperty}
                disabled={addPropertyLoading}
              >
                {addPropertyLoading ? "Saving..." : "Save Property"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Edit Property Modal ── */}
      {isModalOpenEditProperty && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 860, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">
                Edit Property — {selectedProperty?.propertyType}{" "}
                {selectedProperty?.unitNo || selectedProperty?.houseNo}
              </div>
              <button className="modal-close" onClick={closeEditPropertyModal}>
                ✕
              </button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
                maxHeight: "78vh",
                overflowY: "auto",
                padding: 20,
              }}
            >
              {/* ── LEFT ── */}
              <div>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    marginBottom: 12,
                  }}
                >
                  Property Details
                </div>

                {/* Society */}
                <div className="form-group mb12">
                  <label>Society *</label>
                  <select
                    name="societyId"
                    value={editPropertyForm.societyId}
                    onChange={handleEditPropertyChange}
                    style={
                      editPropertyErrors.societyId
                        ? { borderColor: "#dc2626" }
                        : {}
                    }
                  >
                    <option value="">Select Society</option>
                    {societiesList.map((s) => (
                      <option key={s.societyId} value={s.societyId}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                  {editPropertyErrors.societyId && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editPropertyErrors.societyId}
                    </span>
                  )}
                </div>

                {/* Property Type */}
                <div className="form-group mb12">
                  <label>Property Type *</label>
                  <select
                    name="propertyTypeId"
                    value={editPropertyForm.propertyTypeId}
                    onChange={handleEditPropertyChange}
                    style={{ fontSize: 14, fontWeight: 600 }}
                  >
                    <option value="">Select Type</option>
                    {propertyTypes.map((t) => (
                      <option key={t.propertyTypeId} value={t.propertyTypeId}>
                        {t.icon} {t.propertyTypeName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Unit No */}
                {!isEditRowHouse && (
                  <div className="form-group mb12">
                    <label>
                      {isEditRoom ? "Room Number" : "Unit Number"} *
                    </label>
                    <input
                      type="text"
                      name="unitNo"
                      value={editPropertyForm.unitNo}
                      onChange={handleEditPropertyChange}
                      placeholder="e.g. 101, A-204"
                      style={
                        editPropertyErrors.unitNo
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {editPropertyErrors.unitNo && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editPropertyErrors.unitNo}
                      </span>
                    )}
                  </div>
                )}

                {/* House No */}
                {isEditRowHouse && (
                  <div className="form-group mb12">
                    <label>House Number *</label>
                    <input
                      type="text"
                      name="houseNo"
                      value={editPropertyForm.houseNo}
                      onChange={handleEditPropertyChange}
                      placeholder="e.g. RH-12, House No. 5"
                      style={
                        editPropertyErrors.unitNo
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {editPropertyErrors.unitNo && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editPropertyErrors.unitNo}
                      </span>
                    )}
                  </div>
                )}

                {/* Floor */}
                <div className="form-group mb12">
                  <label>Floor Number</label>
                  <select
                    name="floor"
                    value={editPropertyForm.floor}
                    onChange={handleEditPropertyChange}
                  >
                    <option value={0}>Ground Floor</option>
                    {Array.from({ length: 20 }, (_, i) => i + 1).map((f) => (
                      <option key={f} value={f}>
                        {f}
                        {f === 1
                          ? "st"
                          : f === 2
                            ? "nd"
                            : f === 3
                              ? "rd"
                              : "th"}{" "}
                        Floor
                      </option>
                    ))}
                  </select>
                </div>

                {/* Room toggles */}
                {isEditRoom && (
                  <div
                    style={{
                      display: "flex",
                      gap: 20,
                      marginBottom: 12,
                      padding: "10px 12px",
                      background: "var(--bg-secondary)",
                      borderRadius: "var(--radius-md)",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      <label className="toggle">
                        <input
                          type="checkbox"
                          name="attachedWashroom"
                          checked={editPropertyForm.attachedWashroom}
                          onChange={handleEditPropertyChange}
                        />
                        <span className="toggle-slider" />
                      </label>
                      Attached Washroom
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      <label className="toggle">
                        <input
                          type="checkbox"
                          name="kitchenAvailable"
                          checked={editPropertyForm.kitchenAvailable}
                          onChange={handleEditPropertyChange}
                        />
                        <span className="toggle-slider" />
                      </label>
                      Kitchen Available
                    </label>
                  </div>
                )}

                {/* Bedrooms / Bathrooms */}
                {!isEditRoom && (
                  <div className="form-grid mb12">
                    <div className="form-group">
                      <label>Bedrooms</label>
                      <select
                        name="bedrooms"
                        value={editPropertyForm.bedrooms}
                        onChange={handleEditPropertyChange}
                      >
                        {[1, 2, 3, 4, 5, 6].map((n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Washrooms</label>
                      <select
                        name="bathrooms"
                        value={editPropertyForm.bathrooms}
                        onChange={handleEditPropertyChange}
                      >
                        {[1, 2, 3, 4].map((n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Financial */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    margin: "14px 0 10px",
                  }}
                >
                  Financial
                </div>

                <div className="form-grid mb12">
                  <div className="form-group">
                    <label>Rent Amount (₹) *</label>
                    <input
                      type="number"
                      name="rentAmount"
                      value={editPropertyForm.rentAmount}
                      onChange={handleEditPropertyChange}
                      placeholder="e.g. 8500"
                      min={0}
                      style={
                        editPropertyErrors.rentAmount
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {editPropertyErrors.rentAmount && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editPropertyErrors.rentAmount}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Security Deposit (₹)</label>
                    <input
                      type="number"
                      name="securityDeposit"
                      value={editPropertyForm.securityDeposit}
                      onChange={handleEditPropertyChange}
                      placeholder="e.g. 17000"
                      min={0}
                    />
                  </div>
                </div>

                <div className="form-group mb12">
                  <label>Rent Due Date</label>
                  <select
                    name="dueDayOfMonth"
                    value={editPropertyForm.dueDayOfMonth}
                    onChange={handleEditPropertyChange}
                  >
                    {[
                      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 25,
                      28,
                    ].map((d) => (
                      <option key={d} value={d}>
                        {d}
                        {d === 1
                          ? "st"
                          : d === 2
                            ? "nd"
                            : d === 3
                              ? "rd"
                              : "th"}{" "}
                        of every month
                      </option>
                    ))}
                  </select>
                </div>

                {/* Bill Charges */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    margin: "14px 0 10px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  Bill Charges
                  <select
                    style={{
                      fontSize: 11,
                      padding: "2px 6px",
                      fontWeight: 400,
                      textTransform: "none",
                      letterSpacing: 0,
                    }}
                    value=""
                    onChange={(e) => {
                      const found = chargeTypes.find(
                        (c) => c.chargeTypeId === Number(e.target.value),
                      );
                      if (found) addEditBillCharge(found);
                    }}
                  >
                    <option value="">+ Add Charge</option>
                    {chargeTypes.map((c) => (
                      <option key={c.chargeTypeId} value={c.chargeTypeId}>
                        {c.icon} {c.chargeTypeName}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  {editPropertyForm.billCharges?.map((charge) => {
                    const methodDisplay = getBillingMethodDisplay(
                      charge.billingMethod,
                    );
                    return (
                      <div
                        key={charge._id}
                        style={{
                          border: "0.5px solid var(--border-light)",
                          borderRadius: "var(--radius-md)",
                          padding: 12,
                          background: "var(--bg-secondary)",
                        }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1.5fr 1fr auto 28px",
                            gap: 8,
                            alignItems: "end",
                            marginBottom: 8,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                              }}
                            >
                              Charge Name
                            </label>
                            <div
                              style={{
                                padding: "7px 10px",
                                background: "var(--bg-primary)",
                                border: "0.5px solid var(--border-mid)",
                                borderRadius: "var(--radius-md)",
                                fontSize: 13,
                                fontWeight: 600,
                              }}
                            >
                              {charge.chargeName}
                            </div>
                          </div>
                          <div className="form-group" style={{ margin: 0 }}>
                            <label style={{ fontSize: 10, marginBottom: 3 }}>
                              Frequency
                            </label>
                            <select
                              value={charge.frequency}
                              onChange={(e) =>
                                updateEditBillCharge(
                                  charge._id,
                                  "frequency",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: 12, padding: "6px 8px" }}
                            >
                              {FREQ_OPTIONS.map((f) => (
                                <option key={f} value={f}>
                                  {f}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                              }}
                            >
                              Billing Method
                            </label>
                            <select
                              value={charge.billingMethod}
                              onChange={(e) =>
                                updateEditBillCharge(
                                  charge._id,
                                  "billingMethod",
                                  e.target.value,
                                )
                              }
                              style={{
                                fontSize: 11,
                                padding: "4px 6px",
                                background: methodDisplay.bg,
                                color: methodDisplay.color,
                                fontWeight: 700,
                                border: "none",
                                borderRadius: 99,
                              }}
                            >
                              {BILLING_METHOD_OPTIONS.map((m) => (
                                <option key={m} value={m}>
                                  {getBillingMethodDisplay(m).label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <button
                            onClick={() => removeEditBillCharge(charge._id)}
                            style={{
                              width: 28,
                              height: 28,
                              border: "0.5px solid #F09595",
                              background: "var(--red-light)",
                              color: "var(--red)",
                              borderRadius: 5,
                              cursor: "pointer",
                              fontSize: 15,
                              alignSelf: "flex-end",
                            }}
                          >
                            ×
                          </button>
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr auto",
                            gap: 12,
                            alignItems: "center",
                          }}
                        >
                          <div className="form-group" style={{ margin: 0 }}>
                            <label style={{ fontSize: 10, marginBottom: 3 }}>
                              {charge.billingMethod === "Percentage"
                                ? "Value (%)"
                                : charge.billingMethod === "PerUnit"
                                  ? "Rate (₹/unit)"
                                  : "Amount (₹)"}
                            </label>
                            <input
                              type="number"
                              value={charge.amount}
                              onChange={(e) =>
                                updateEditBillCharge(
                                  charge._id,
                                  "amount",
                                  e.target.value,
                                )
                              }
                              placeholder={
                                charge.billingMethod === "PerUnit"
                                  ? "e.g. 8.5"
                                  : charge.billingMethod === "Percentage"
                                    ? "e.g. 10"
                                    : "e.g. 500"
                              }
                              min={0}
                              step="0.01"
                              style={{ fontSize: 12, padding: "6px 8px" }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Partial Pay
                            </label>
                            <label className="toggle">
                              <input
                                type="checkbox"
                                checked={charge.allowPartialPay}
                                onChange={(e) =>
                                  updateEditBillCharge(
                                    charge._id,
                                    "allowPartialPay",
                                    e.target.checked,
                                  )
                                }
                              />
                              <span className="toggle-slider" />
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* ── RIGHT ── */}
              <div>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    marginBottom: 10,
                  }}
                >
                  Property Amenities
                </div>

                <div
                  style={{
                    maxHeight: 300,
                    overflowY: "auto",
                    paddingRight: 4,
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                  >
                    {(amenitiesList || [])?.map((amenity) => (
                      <label
                        key={amenity.amenityId}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 8,
                          fontSize: 12,
                          cursor: "pointer",
                          padding: "6px 10px",
                          border: `0.5px solid ${editPropertyForm.amenityIds?.includes(amenity.amenityId) ? "var(--blue)" : "var(--border-light)"}`,
                          borderRadius: "var(--radius-md)",
                          background: editPropertyForm.amenityIds?.includes(
                            amenity.amenityId,
                          )
                            ? "var(--blue-light)"
                            : "var(--bg-primary)",
                          userSelect: "none",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            editPropertyForm.amenityIds?.includes(
                              amenity.amenityId,
                            ) || false
                          }
                          onChange={() =>
                            handleEditAmenityToggle(amenity.amenityId)
                          }
                          style={{ marginTop: 2, flexShrink: 0 }}
                        />
                        <span style={{ fontSize: 16, flexShrink: 0 }}>
                          {amenity.icon}
                        </span>
                        <span>
                          <span style={{ fontWeight: 600 }}>
                            {amenity.amenityName}
                          </span>
                          {amenity.description && (
                            <div
                              style={{
                                fontSize: 10,
                                color: "var(--text-tertiary)",
                                marginTop: 1,
                                lineHeight: "1.4",
                              }}
                            >
                              {amenity.description}
                            </div>
                          )}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Custom Amenity */}
                <div className="form-group mb12">
                  <label>Custom Amenity</label>
                  <input
                    type="text"
                    name="customAmenity"
                    value={editPropertyForm.customAmenity}
                    onChange={handleEditPropertyChange}
                    placeholder="Add a custom amenity not listed"
                  />
                </div>

                {/* Area */}
                <div className="form-group mb12">
                  <label>Area (sq ft)</label>
                  <input
                    type="number"
                    name="areaSqFt"
                    value={editPropertyForm.areaSqFt}
                    onChange={handleEditPropertyChange}
                    placeholder="e.g. 450"
                    min={0}
                  />
                </div>

                {/* Notes */}
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "var(--text-tertiary)",
                    textTransform: "uppercase",
                    letterSpacing: ".06em",
                    margin: "14px 0 10px",
                  }}
                >
                  Instructions / Notes for Tenant
                </div>
                <textarea
                  name="notes"
                  value={editPropertyForm.notes}
                  onChange={handleEditPropertyChange}
                  style={{ minHeight: 110, width: "100%" }}
                  placeholder="e.g. No loud music after 10 PM."
                />
                <div className="input-hint" style={{ marginTop: 4 }}>
                  Shown to the tenant in their dashboard and agreement
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn"
                onClick={closeEditPropertyModal}
                disabled={editPropertyLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateProperty}
                disabled={editPropertyLoading}
              >
                {editPropertyLoading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Assign Tenant Modal ── */}
      {isModalOpenAssignTenant && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 460 }}>
            <div className="modal-header">
              <div className="modal-title">Assign Room to Tenant</div>
              <button
                className="modal-close"
                onClick={() => setIsModalOpenAssignTenant(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
                {selectedPropertyForAssign?.societyName} —{" "}
                {selectedPropertyForAssign?.unitNo ||
                  selectedPropertyForAssign?.houseNo}
              </div>
              <div className="form-group mb12">
                <label>Select Tenant</label>
                <select
                  value={assignTenantId}
                  onChange={(e) => setAssignTenantId(e.target.value)}
                  style={{ width: "100%" }}
                >
                  <option value="">— Select tenant —</option>
                  {isTenantsListData?.map((t) => (
                    <option key={t.tenantId} value={t.tenantId}>
                      {t.fullName} — {t.mobile} | KYC: {t.kycStatus}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn"
                onClick={() => setIsModalOpenAssignTenant(false)}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleAssignSave}>
                Save Assignment
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
